function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#fff;stroke-width:0.75px;}.cls-3{isolation:isolate;}.cls-4{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Zeichenfl\xE4che 1");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Gruppe_453",
  "data-name": "Gruppe 453"
}, React.createElement("g", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9"
}, React.createElement("circle", {
  className: "cls-1",
  cx: 4.98,
  cy: 4.98,
  r: 4.98
}), React.createElement("circle", {
  className: "cls-2",
  cx: 4.98,
  cy: 4.98,
  r: 4.43
})), React.createElement("g", {
  id: "_",
  "data-name": " ",
  className: "cls-3"
}, React.createElement("g", {
  className: "cls-3"
}, React.createElement("path", {
  className: "cls-4",
  d: "M2.92,3.89A2.67,2.67,0,0,1,3.07,3a1.83,1.83,0,0,1,.43-.69,1.86,1.86,0,0,1,.68-.44,2.36,2.36,0,0,1,.9-.16,2.43,2.43,0,0,1,.77.12,2,2,0,0,1,.62.35,1.73,1.73,0,0,1,.42.57A1.94,1.94,0,0,1,7,3.51,1.73,1.73,0,0,1,7,4.05a1.22,1.22,0,0,1-.18.4,1.41,1.41,0,0,1-.25.29L6.25,5l-.32.28a1.81,1.81,0,0,0-.25.3A1.39,1.39,0,0,0,5.51,6a2.87,2.87,0,0,0,0,.55h-1a6,6,0,0,1,0-.67,2.09,2.09,0,0,1,.13-.48A1.57,1.57,0,0,1,4.87,5a3.22,3.22,0,0,1,.32-.32l.27-.23a1.31,1.31,0,0,0,.23-.24.92.92,0,0,0,.17-.29,1.15,1.15,0,0,0,0-.39,1.08,1.08,0,0,0-.09-.46.93.93,0,0,0-.23-.31A.79.79,0,0,0,5.3,2.6.74.74,0,0,0,5,2.54a1,1,0,0,0-.82.37,1.61,1.61,0,0,0-.27,1ZM4.35,7.14h1.2V8.27H4.35Z"
}))));

var SvgIconInfo = function SvgIconInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 9.96 9.96",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_info.d17889e9.svg";
export { ForwardRef as ReactComponent };